import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'

dayjs.extend(utc)

export function formatUtcString(
  utcString: string,
  formatPattern: string = DATE_TIME_FORMAT
): string {
  return dayjs.utc(utcString).format(formatPattern)
}

export function yesterday(): string {
  return dayjs().subtract(1, 'day').format('YYYY-MM-DD')
}

export function toDay(): string {
  return dayjs().format('YYYY-MM-DD')
}

export function reverseTimestamp() {
  return Date.now().toString().split('').reverse().join('')
}
export function secondToString(duration: number): string {
  if (duration === 0) {
    return '0秒'
  }
  let str = ''
  if (duration >= 3600) {
    str += parseInt((duration / 3600).toString()) + '小时'
    duration %= 3600
  }
  if (duration >= 60) {
    str += parseInt((duration / 60).toString()) + '分'
    duration %= 60
  }
  if (duration > 0) {
    str += duration + '秒'
  }
  return str
}

export function secondToMin(duration: number): number {
  return duration / 60
}

export function formatUnixTime(timestamp: number): string {
  const time = new Date(timestamp)
  return (
    time.getFullYear() +
    '-' +
    String(time.getMonth() + 1).padStart(2, '0') +
    '-' +
    String(time.getDate()).padStart(2, '0') +
    ' ' +
    String(time.getHours()).padStart(2, '0') +
    ':' +
    String(time.getMinutes()).padStart(2, '0') +
    ':' +
    String(time.getSeconds()).padStart(2, '0')
  )
}
